class CountryModal extends HTMLElement {
  constructor() {
    super();

    this.modal = this;
    this.hideModal = localStorage.getItem('hide_country_modal');
    this.hideModalTime = localStorage.getItem('hide_country_modal_time');

    if (this.hideModal === 'true' && this.hideModalTime) {
      const now = Date.now();
      const timeElapsed = now - parseInt(this.hideModalTime, 10);
    
      if (timeElapsed > 86400000) { // 24 timer
        localStorage.removeItem('hide_country_modal');
        localStorage.removeItem('hide_country_modal_time');
        this.hideModal = null; //
      }
    }

    this.hideModalCountries = this.getAttribute('data-hide-modal');
    this.showModalCountries = this.getAttribute('data-show-modal');

    this.countryButton = this.querySelector('.country-modal__button');

    this.closeButton = this.querySelectorAll('[data-close-modal').forEach((button) => {
      button.addEventListener('click', () => {
        this.close();
      })
    });
  }

  async connectedCallback() {
    const country = await this.getVisitorCountry();

    //this.countryButton.innerText = country;

    // Check if the modal should be hidden for the current country
    if (this.hideModal !== 'true') {
      if ( this.showModalCountries !== "" && this.showModalCountries.includes(country) ) {
        this.open();
      }

      if (this.hideModalCountries !== "" && !this.hideModalCountries.includes(country) ) {
        this.open();
      }

    }
  }

  async getVisitorCountry() {
    const response = await fetch('browsing_context_suggestions.json');
    const data = await response.json();
    return data.detected_values.country.name; // Returns the country name
  }

  open() {
    this.classList.add('country-modal--open')
    document.querySelector('body').classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('country-modal--open');
    document.querySelector('body').classList.remove('overflow-hidden');

    localStorage.setItem('hide_country_modal', true)
    localStorage.setItem('hide_country_modal_time', Date.now().toString());
  }
}

customElements.define("country-modal", CountryModal);
